export * from './mito'
export * from './vault'
export * from './mixpanel'
export * from './launchpad'

export enum LayoutOption {
  Grid = 'grid',
  Table = 'table'
}

export enum WalletModalType {
  All = 'all',
  Ledger = 'ledger',
  Trezor = 'trezor'
}

export enum HomeCategory {
  NewToCrypto = 'newToCrypto',
  CryptoEnthusiast = 'cryptoEnthusiast'
}

export enum EventBus {
  VaultStake = 'vault-stake',
  VaultRedeem = 'vault-redeem',
  VaultSubscribe = 'vault-subscribe',
  ClaimIDOTokens = 'claim-ido-tokens',
  ClaimVestingTokens = 'claim-vesting-tokens',
  StreamVaultTransferUpdate = 'stream-vault-transfer-update',
  StreamHistoricalStakingUpdate = 'stream-historical-staking-update'
}

export enum StreamType {
  Vault = 'vault',
  SpotTrades = 'spot-trades',

  BankBalance = 'bank-balance',
  OraclePrices = 'oracle-prices',
  VaultTransfers = 'vault-transfers',
  HistoricalStaking = 'historical-staking',
  SubaccountBalances = 'subaccount-balances',
  HolderSubscriptions = 'holder-subscriptions',
  SpotOrderbookUpdate = 'spot-orderbook-update',
  SpotSubaccountTrades = 'spot-subaccount-trades',
  SpotSubaccountOrders = 'spot-subaccount-orders',

  StakingRewardByAccount = 'staking-reward-by-account',
  DerivativeOrderbookUpdate = 'derivative-orderbook-update',
  DerivativeSubaccountTrades = 'derivative-subaccount-trades',
  DerivativesSubaccountOrders = 'derivatives-subaccount-orders',
  DerivativesSubaccountPositions = 'derivatives-subaccount-positions'
}

export enum Modal {
  Stake = 'stake',
  Unstake = 'unstake',
  VaultCta = 'vault-cta',
  SelectToken = 'select-token',
  SwapSuccess = 'swap-success',
  ClaimReward = 'claim-rewards',
  ClaimUnstake = 'claim-unstake',
  IDOSubscribe = 'ido-subscribe',
  WalletQRCode = 'wallet-qr-code',
  GeoRestricted = 'geo-restricted',
  WalletConnect = 'wallet-connect',
  IDOClaimTokens = 'ido-claim-tokens',
  ConfirmPurchase = 'confirm-purchase',
  CreateLaunchpad = 'create-launchpad',
  MissionConcluded = 'mission-concluded',
  MissionDescription = 'mission-description',
  WalletConnectTerms = 'wallet-connect-terms',
  ExperimentalMessage = 'experimental-message',
  DepositToSpotVault = 'deposit-to-spot-vault',
  RedeemFromSpotVault = 'redeem-from-spot-vault',
  IDOClaimVestedTokens = 'ido-claim-vested-tokens',
  DepositToDerivativeVault = 'deposit-to-derivative-vault',
  RedeemFromDerivativeVault = 'redeem-from-derivative-vault',
  PermissionlessMarketRedirect = 'permissionless-market-redirect'
}
